//import { Project, ProjectAndCustomer } from './projectType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class PhotoApi {

    static async getAllPhotoLinks(imageForTag: string, Id: string) {
        try {

            const response = await fetch(`${API_BASE_URL}/images/get_all_photo_links/${imageForTag}/${Id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();
            if (response.ok) {  // Using response.ok instead of checking status === 200
                return responseBody.photos;  // Return the photos array directly
            
            } 
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }

        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get count: ${error.message}`);
            } else {
                throw new Error('Failed to get count: An unknown error occurred.');
            }
        }
    }


    static async getPhotoLinks(imageForTag: string, image_size_tag: string, Id: string, imageProjectTag?: string) {
        try {
            // Build the base URL with required parameters
            let url = `${API_BASE_URL}/images/get_photo_links?image_for_tag=${imageForTag}`;

            // Add the appropriate ID parameter based on imageForTag
            switch (imageForTag) {
                case 'project':
                    url += `&project_id=${Id}`;
                    // Add image_project_tag only for project images if provided
                    if (imageProjectTag) {
                        url += `&image_project_tag=${imageProjectTag}`;
                    }
                    break;
                case 'company':
                    url += `&company_code=${Id}`;
                    break;
                case 'account':
                    url += `&account_id=${Id}`;
                    break;
                default:
                    throw new Error('Invalid image_for_tag');
            }

            // Add image_size_tag parameter 
            url += `&image_size_tag=${image_size_tag}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();
            if (response.ok) {  // Using response.ok instead of checking status === 200
                return responseBody.photos;  // Return the photos array directly
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            } 
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get photos: ${error.message}`);
            } else {
                throw new Error('Failed to get photos: An unknown error occurred.');
            }
        }
    }

    static async getPhotoCount(imageForTag: string, Id: string) {
        try {

            const response = await fetch(`${API_BASE_URL}/images/photo_count/${imageForTag}/${Id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {
                //const account: Account = responseBody.data.attributes;
                return responseBody.count;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get count: ${error.message}`);
            } else {
                throw new Error('Failed to get count: An unknown error occurred.');
            }
        }
    }


    static async upload(
        file: File,
        params: {
            project_id?: number;
            company_code?: number;
            account_id?: number;
            image_project_tag?: string;
            image_for_tag: 'project' | 'company' | 'account';
            image_size_tag: string;
        }
    ): Promise<any> {
        const formData = new FormData();
        formData.append('image', file);

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined) {
                formData.append(key, value.toString());
            }
        });

        try {
            // Send the POST request to your API endpoint.
            const response = await fetch(`${API_BASE_URL}/images`, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });


            const responseBody = await response.json();

            if (response.ok) {
                // Successfully uploaded. You might return the response or process it further.
                return responseBody;
            } 
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                // Log error details if needed and throw an error.
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to upload image: ${error.message}`);
            } else {
                throw new Error('Failed to upload image: An unknown error occurred.');
            }
        }
    }


    static async delete(imageId: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/images/${imageId}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete photo: ${error.message}`);
            } else {
                throw new Error('Failed to delete photo: An unknown error occurred.');
            }
        }
    }

}

export default PhotoApi;